/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. (Vue 3 Migration)
==========================================================================================*/

import { createRouter, createWebHistory } from 'vue-router';
import service from './services';
import functions from './utils/functions';
import jwt from 'jsonwebtoken';
import ability from './services/ability';
import { decryptData } from './services/decryptData';

// =============================================================================
// ROTAS
// =============================================================================
const routes = [
  {
    // =============================================================================
    // MAIN LAYOUT ROUTES (Requer Autenticação)
    // =============================================================================
    path: '',
    redirect: '/dashboard',
    meta: { requiresAuth: true }, // Define que filhos precisam de auth
    component: () => import('./v2/PageLayout.vue'),
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: true },
      },
      {
        path: '/veiculos',
        name: 'Veículos',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/veiculos/:vehicleId/historico-de-observacoes',
        name: 'Veículos - Histórico de Observações',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/veiculos/:vehicleId/historico-de-alteracoes',
        name: 'Veículos - Histórico de Alterações',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/cadastro-bancario',
        name: 'Listagem',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/cadastro-bancario/analise-financeira',
        name: 'Análise de Contas',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/makemore/configuracao',
        name: 'Configurações',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/makemore',
        name: 'Listagem Make More',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/carteira-distribuicao',
        name: 'Distribuição de Cobranças',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/corretagens',
        name: 'Listagem de Corretagem',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/corretagens/solicitacao',
        name: 'Solicitação de corretagem',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/corretagens/recebimentos',
        name: 'Recebimentos',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/comercial/configuracoes',
        name: 'Ranking Comercial',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/fecha-bem/configuracoes',
        name: 'Configurações',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/fecha-bem',
        name: 'Listagem',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/oficinas',
        name: 'Oficinas',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/oficinas/:id',
        name: 'Oficinas',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/eventos/parecer-juridico',
        name: 'Parecer Jurídico',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/eventos/listagem',
        name: 'Listagem de Eventos',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/eventos/custos/:eventId',
        name: 'Custo do Sinistro',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/eventos/custos/:eventId/:thirdId',
        name: 'Custo do Sinistro',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/eventos/custos/listagem',
        name: 'Custos',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/eventos/analise/:eventId',
        name: 'Análise de Evento',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/eventos/analise/:eventId/:thirdId',
        name: 'Análise de Evento',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/eventos/acompanhamento-de-pecas',
        name: 'Peças',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/eventos/esteira-de-processos',
        name: 'Esteira de Processos',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/eventos/configuracoes',
        name: 'Tipos de Arquivos',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/eventos/monitoramento',
        name: 'Monitoramento de Eventos',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/Associados',
        name: 'Associados',
        component: () => import('./views/menu/Associados.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Benefíciarios', active: true },
          ],
          pageTitle: 'Benefíciarios',
          rule: 'editor',
        },
      },
      {
        path: '/DetalheAssociado/:idAssociado',
        name: 'DetalheAssociado',
        component: () => import('./views/menu/Associado-Detalhe.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Detalhes', active: true },
          ],
          pageTitle: 'Detalhes do Benefíciario',
          checkPermission: false,
        },
      },
      {
        path: '/EditarAssociado/:idAssociado',
        name: 'EditarAssociado',
        component: () => import('./views/menu/editarAssociado.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Editar', active: true },
          ],
          pageTitle: 'Editar dados do Beneficiário',
          checkPermission: false,
        },
      },
      {
        path: '/Cotacoes',
        name: 'Cotações',
        component: () => import('./views/menu/Cotacoes.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Painel Propostas', active: true },
          ],
          pageTitle: 'Painel Propostas',
          rule: 'editor',
        },
      },
      {
        path: '/CotacoesB2C',
        name: 'Cotações B2C',
        component: () => import('./views/menu/CotacoesB2C.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Cotações Consultor Online', active: true },
          ],
          pageTitle: 'Cotações Consultor Online',
          rule: 'editor',
        },
      },
      {
        path: '/PainelLeadsB2C',
        name: 'Painel de Leads B2C',
        component: () => import('./views/menu/b2c/PainelLeadsB2CView.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Painel de Leads B2C', active: true },
          ],
          pageTitle: 'Painel de Leads B2C',
          rule: 'editor',
        },
      },
      {
        path: '/novaProposta/Interno',
        name: 'novaPropostaInterno',
        component: () => import('@/views/pages/novaProposta.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Nova Proposta', active: true },
          ],
          pageTitle: 'Nova Proposta',
          checkPermission: false,
        },
      },
      {
        path: '/novaProposta/multi-proposta',
        name: 'Proposta Múltipla',
        component: () =>
          import(
            './views/menu/propostas/multi-propostas/FormMultiProposta.vue'
          ),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Nova Proposta', url: '/novaProposta/Interno' },
            { title: 'Multi Proposta', active: true },
          ],
          pageTitle: 'Multi Proposta',
          checkPermission: false,
          rule: 'editor',
        },
      },
      {
        path: '/novaPreCotacao',
        name: 'Nova Pré-Cotação',
        component: () => import('./views/forms/formPreCotacao.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Nova Pré-Cotação', active: true },
          ],
          pageTitle: 'Nova Pré-Cotação',
          checkPermission: true,
        },
      },
      {
        path: '/cadastro-ranking',
        name: 'Ranking Cadastro',
        component: () =>
          import('./views/pages/RankingRegister/RankingRegisterView.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Ranking Cadastro', active: true },
          ],
          pageTitle: 'Ranking Cadastro',
        },
      },
      {
        path: '/fechamento',
        name: 'Fechamento',
        component: () =>
          import('./views/menu/financeiro/Fechamento/FechamentoView.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Financeiro' },
            { title: 'Fechamento', active: true },
          ],
          pageTitle: 'Fechamento',
          rule: 'editor',
        },
      },
      {
        path: '/Extrato',
        name: 'Extrato',
        component: () => import('./views/menu/financeiro/Extrato.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Extrato', active: true },
          ],
          pageTitle: 'Extrato',
          rule: 'editor',
        },
      },
      {
        path: '/PainelFinanceiro',
        name: 'Painel Financeiro',
        component: () => import('./views/menu/financeiro/PainelFinanceiro.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Painel Financeiro', active: true },
          ],
          pageTitle: 'Painel Financeiro',
          rule: 'editor',
        },
      },
      {
        path: '/ArquivoRemessa',
        name: 'Arquivo Remessa',
        component: () => import('./views/menu/financeiro/arquivoRemessa.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Arquivo Remessa', active: true },
          ],
          pageTitle: 'Arquivo Remessa',
          rule: 'editor',
        },
      },
      {
        path: '/ArquivoRetorno',
        name: 'Arquivo Retorno',
        component: () => import('./views/menu/financeiro/arquivoRetorno.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Arquivo Retorno', active: true },
          ],
          pageTitle: 'Arquivo Retorno',
          rule: 'editor',
        },
      },
      {
        path: '/gestao-status',
        name: 'Gestão Status',
        component: () =>
          import('./views/menu/financeiro/Gestao-Status/GestaoStatusView.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Gestão Status', active: true },
          ],
          pageTitle: 'Gestão Status',
          rule: 'editor',
        },
      },
      {
        path: '/pagamentos-inconsistentes',
        name: 'Pagamentos Inconsistentes',
        component: () =>
          import(
            './views/menu/financeiro/Pagamentos-Inconsistentes/PagamentosInconsistentesView.vue'
          ),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Pagamentos Inconsistentes', active: true },
          ],
          pageTitle: 'Pagamentos Inconsistentes',
          rule: 'editor',
        },
      },
      {
        path: '/agentes-de-cobranca',
        name: 'Agentes de Cobrança',
        component: () =>
          import('./views/pages/agentesCobranca/agentesCobranca.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Agentes de Cobrança', active: true },
          ],
          pageTitle: 'Agentes de Cobrança',
          rule: 'editor',
        },
      },
      {
        path: '/Ouvidoria',
        name: 'Ouvidoria',
        component: () => import('./views/menu/relacionamentos/Ouvidoria.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Ouvidoria', active: true },
          ],
          pageTitle: 'Fale Conosco',
          rule: 'editor',
        },
      },
      {
        path: '/Cancelamentos',
        name: 'Cancelamentos',
        component: () =>
          import('./views/menu/relacionamentos/Cancelamentos.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Cancelamentos', active: true },
          ],
          pageTitle: 'Cancelamentos',
          rule: 'editor',
        },
      },
      {
        path: '/NovoCancelamento',
        name: 'NovoCancelamento',
        component: () =>
          import('./views/menu/relacionamentos/NovoCancelamento.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Novo Cancelamento', active: true },
          ],
          pageTitle: 'Novo Cancelamento',
          checkPermission: false,
        },
      },
      {
        path: '/Checklist',
        name: 'Checklist',
        component: () => import('./views/menu/assistencia/checklist.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Checklist', active: true },
          ],
          pageTitle: 'Checklist',
          rule: 'editor',
        },
      },
      {
        path: '/PreAberturaEvento',
        name: 'Eventos',
        component: () => import('./views/forms/formPreAberturaEvento.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Eventos', url: '/eventos/painel' },
            { title: 'Pré Abertura de Evento', active: true },
          ],
          pageTitle: 'Pré Abertura de Evento',
          rule: 'editor',
        },
      },
      {
        path: '/NovoChecklist',
        name: 'Novo Checklist',
        component: () => import('./views/forms/formDadosDoChecklist.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Novo Checklist', active: true },
          ],
          pageTitle: 'Novo Checklist',
          rule: 'editor',
          checkPermission: false,
        },
      },
      {
        path: '/EditarChecklist/:idChecklist',
        name: 'Editar Checklist',
        component: () => import('./views/forms/formEditarDadosDoChecklist.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Editar Checklist', active: true },
          ],
          pageTitle: 'Editar Checklist',
          rule: 'editor',
          checkPermission: false,
        },
      },
      {
        path: '/Pre-Cotacoes',
        name: 'Pré Cotações',
        component: () => import('./views/menu/PreCotacao.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Pré Cotações', active: true },
          ],
          pageTitle: 'Pré Cotações',
          rule: 'editor',
        },
      },
      {
        path: '/DetalheCancelamento/:idCancelamento',
        name: 'DetalheCancelamento',
        component: () =>
          import('./views/menu/relacionamentos/ExibeCancelamento.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Detalhes', active: true },
          ],
          pageTitle: 'Detalhes do Cancelamento',
          checkPermission: false,
        },
      },
      {
        path: '/EditarCancelamento/:idCancelamento',
        name: 'EditarCancelamento',
        component: () =>
          import('./views/menu/relacionamentos/NovoCancelamento.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Editarr', active: true },
          ],
          pageTitle: 'Editar Cancelamento',
          checkPermission: false,
        },
      },
      {
        path: '/ChamadosInternos',
        name: 'Chamados Internos',
        component: () =>
          import('./views/menu/relacionamentos/ChamadosInternos.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Chamados Internos', active: true },
          ],
          pageTitle: 'Chamados Internos',
          rule: 'editor',
        },
      },
      {
        path: '/Chamado',
        name: 'Fale com Especialista',
        component: () => import('./views/menu/Chamado.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Chamados com o Especialista', active: true },
          ],
          pageTitle: 'Fale com o Especialista',
          rule: 'editor',
        },
      },
      {
        path: '/Vistorias',
        name: 'Vistorias',
        component: () => import('./views/menu/Vistorias.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Vistorias', active: true },
          ],
          pageTitle: 'Vistorias',
          rule: 'editor',
        },
      },
      {
        path: '/eventos',
        name: 'Painel Antigo',
        component: () =>
          import('./views/menu/eventos/Eventos-List/Eventos-List.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Painel Eventos', active: true },
          ],
          pageTitle: 'Painel Eventos',
          rule: 'editor',
        },
      },
      {
        path: '/eventos/painel',
        name: 'Painel de Eventos',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/SituacoesEvento',
        name: 'Situação de Evento',
        component: () =>
          import(
            './views/menu/eventos/situacoes-evento/situacoes-evento-list.vue'
          ),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Eventos', url: '/eventos/painel' },
            { title: 'Situação de Evento', active: true },
          ],
          pageTitle: 'Situação de Evento',
          rule: 'editor',
          checkPermission: true,
        },
      },
      {
        path: '/MotivosEvento',
        name: 'Motivo de Evento',
        component: () =>
          import('./views/menu/eventos/motivos-evento/motivos-evento-list.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Eventos', url: '/eventos/painel' },
            { title: 'Motivo de Evento', active: true },
          ],
          pageTitle: 'Motivo de Evento',
          rule: 'editor',
          checkPermission: true,
        },
      },
      {
        path: '/detalheVistoria/:idCotacao',
        name: 'detalheVistoria',
        component: () => import('./views/menu/VistoriasDetalhes.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Vistorias', url: '/Vistorias' },
            { title: 'Detalhe', active: true },
          ],
          pageTitle: 'Detalhe',
          rule: 'editor',
          checkPermission: false,
        },
      },
      {
        path: '/editarCotacao/:idCotacao',
        name: 'editarCotacao',
        component: () => import('./views/menu/editarCotacao2.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Cotações', url: '/Cotacoes' },
            { title: 'Editar', active: true },
          ],
          pageTitle: 'Editar',
          rule: 'editor',
          checkPermission: false,
        },
      },
      {
        path: '/editarCotacao2/:idCotacao',
        name: 'editarCotacao2',
        component: () => import('./views/menu/editarCotacao2.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Cotações', url: '/Cotacoes' },
            { title: 'Editar', active: true },
          ],
          pageTitle: 'Editar',
          rule: 'editor',
          checkPermission: false,
        },
      },

      {
        path: '/editar-evento/:idEvento',
        name: 'editarEvento-v2',
        component: () =>
          import('./views/menu/eventos/Eventos/EditarEventoView.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Painel Eventos', url: '/eventos/painel' },
            { title: 'Editar Eventos', active: true },
          ],
          pageTitle: 'Editar Eventos',
          rule: 'editor',
          checkPermission: false,
        },
      },
      {
        path: '/editar-eventos-terceiro/:idEvento/:idTerceiro',
        name: 'editar-eventos-terceiro',
        // BEFORE ENTER MANTIDO POIS ALTERA BREADCRUMB LOCALMENTE
        beforeEnter: function (to, from, next) {
          const breadcrumb = to.meta.breadcrumb;
          const idEvento = to.params.idEvento;
          breadcrumb[2].title = `Evento - ${idEvento}`;
          breadcrumb[2].url = `/editar-evento/${idEvento}`;
          next();
        },
        component: () =>
          import(
            './views/menu/eventos/Eventos-Terceiros/EditarTerceirosView.vue'
          ),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Painel Eventos', url: '/eventos/painel' },
            { title: 'Evento', url: '/editar-evento/:idEvento', active: true },
            { title: 'Editar Terceiro', active: true },
          ],
          pageTitle: 'Editar Terceiro',
          rule: 'editor',
          checkPermission: false,
        },
      },
      {
        path: '/editar-eventos-patrimonio/:idEvento/:idPatrimonio',
        name: 'editar-eventos-patrimonio',
        // BEFORE ENTER MANTIDO POIS ALTERA BREADCRUMB LOCALMENTE
        beforeEnter: function (to, from, next) {
          const breadcrumb = to.meta.breadcrumb;
          const idEvento = to.params.idEvento;
          breadcrumb[2].title = `Evento - ${idEvento}`;
          breadcrumb[2].url = `/editar-evento/${idEvento}`;
          next();
        },
        component: () =>
          import(
            './views/menu/eventos/Eventos-Patrimonio/EditarPatrimonioView.vue'
          ),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Painel Eventos', url: '/eventos/painel' },
            { title: 'Evento', url: '/editar-evento/:idEvento', active: true },
            { title: 'Editar Patrimônio', active: true },
          ],
          pageTitle: 'Editar Patrimônio',
          rule: 'editor',
          checkPermission: false,
        },
      },
      {
        path: '/evento-analise/:idEvento',
        name: 'Análise de Eventos',
        component: () =>
          import('./views/menu/eventos/Eventos-Analise/EventosAnaliseView.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Eventos', url: '/eventos/painel' },
            { title: 'Análise do Evento', active: true },
          ],
          pageTitle: 'Análise do Evento',
          rule: 'editor',
        },
      },
      {
        path: '/novo-evento',
        name: 'novo-evento',
        component: () =>
          import('./views/menu/eventos/Novo-Evento/NovoEventoView.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Painel Eventos', url: '/eventos/painel' },
            { title: 'Novo Evento', active: true },
          ],
          pageTitle: 'Novo Evento',
          rule: 'editor',
          checkPermission: false,
        },
      },
      {
        path: '/editarOuvidoria/:idOuvidoria',
        name: 'editarOuvidoria',
        component: () =>
          import('./views/menu/relacionamentos/editarOuvidoria.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Ouvidorias', url: '/Ouvidoria' },
            { title: 'Editar', active: true },
          ],
          pageTitle: 'Editar',
          rule: 'editor',
          checkPermission: false,
        },
      },
      {
        path: '/editarChamado/:idChamado',
        name: 'editarChamado',
        component: () => import('./views/menu/editarChamado.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Chamados', url: '/Chamado' },
            { title: 'Editar', active: true },
          ],
          pageTitle: 'Editar',
          rule: 'editor',
          checkPermission: false,
        },
      },
      {
        path: '/editarChamadoInterno/:idChamado',
        name: 'editarChamadoInterno',
        component: () =>
          import('./views/menu/relacionamentos/editarChamadoInterno.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Chamados Internos', url: '/ChamadosInternos' },
            { title: 'Editar', active: true },
          ],
          pageTitle: 'Editar',
          rule: 'editor',
          checkPermission: false,
        },
      },
      {
        path: '/Graficos/Crescimento',
        name: 'Crescimento',
        component: () => import('./views/menu/graficos/crescimento.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Relatórios', active: true },
          ],
          pageTitle: 'Crescimento de Base',
          rule: 'editor',
        },
      },
      {
        path: '/Graficos/Vendas',
        name: 'Vendas',
        component: () => import('./views/menu/graficos/vendas.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Relatórios', active: true },
          ],
          pageTitle: 'Vendas',
          rule: 'editor',
        },
      },
      {
        path: '/Graficos/Cancelamentos',
        name: 'CancelamentosGraficos',
        component: () => import('./views/menu/graficos/cancelamentos.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Relatórios', active: true },
          ],
          pageTitle: 'Cancelamentos Graficos',
          rule: 'editor',
        },
      },
      {
        path: '/Consolidado',
        name: 'Consolidado',
        component: () => import('./views/menu/graficos/Consolidado.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Relatórios', active: true },
          ],
          pageTitle: 'Painel de Vendas',
          rule: 'editor',
        },
      },
      {
        path: '/SuperRanking',
        name: 'Super Ranking',
        component: () =>
          import('./views/pages/PainelComercial/PainelComercialView.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Relatórios', active: true },
          ],
          pageTitle: 'Super Ranking',
          rule: 'editor',
        },
      },
      {
        path: '/relatorio-rastreador',
        name: 'Relatório Rastreador',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/PodioAnual',
        name: 'Pódio Anual',
        component: () => import('./views/pages/PodioAnual/AnnualPodiumView'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Relatórios', active: true },
          ],
          pageTitle: 'Pódio Anual',
          rule: 'editor',
        },
      },
      {
        path: '/endosso',
        name: 'Endosso',
        component: () => import('./views/pages/Relatorio/EndossoView.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Relatórios', active: true },
          ],
          pageTitle: 'Endosso',
          rule: 'editor',
          checkPermission: false,
        },
      },
      {
        path: '/conciliacao',
        name: 'Conciliação',
        component: () => import('./views/pages/Relatorio/ConciliacaoView.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Relatórios', active: true },
          ],
          pageTitle: 'Conciliação',
          rule: 'editor',
          checkPermission: false,
        },
      },
      {
        path: '/Dinamicos',
        name: 'Dinamicos',
        component: () =>
          import(
            './views/menu/relatorios/dinamicos/RelatoriosDinamicosView.vue'
          ),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Relatórios Dinâmicos', active: true },
          ],
          pageTitle: 'Relatórios Dinâmicos',
          rule: 'editor',
        },
      },
      {
        path: '/Graficos/VendasComissionadas',
        name: 'Vendas Comissionadas',
        component: () =>
          import('./views/menu/graficos/VendasComissionadas.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Relatórios', active: true },
          ],
          pageTitle: 'Vendas Comissionadas',
          rule: 'editor',
        },
      },
      {
        path: '/Graficos/Criticas',
        name: 'Criticas',
        component: () => import('./views/menu/relatorios/Relatorios.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Graficos', active: true },
          ],
          pageTitle: 'Criticas',
          rule: 'editor',
        },
      },
      {
        path: '/marketing/painel-de-leads',
        name: 'Painel de Leads',
        component: () =>
          import('./views/menu/marketing/painel-leads/PainelLeadsView.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Marketing', active: true },
            { title: 'Painel de Leads', active: true },
          ],
          pageTitle: 'Painel de Leads',
          rule: 'editor',
        },
      },
      // =============================================================================
      // MENU ADMINISTRADOR (CADASTRO)
      // =============================================================================
      {
        path: '/empresa',
        name: 'Empresa',
        component: () => import('./views/menu/cadastros/empresa.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Cadastro', active: true },
          ],
          pageTitle: 'Empresa',
          rule: 'editor',
        },
      },
      {
        path: '/usuarios',
        name: 'Usuário',
        component: () => import('./views/menu/cadastros/usuarios.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Cadastro', active: true },
          ],
          pageTitle: 'Usuários',
          rule: 'editor',
        },
      },
      {
        path: '/vistoriadores',
        name: 'Vistoriador',
        component: () => import('./views/menu/cadastros/vistoriadores.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Cadastro', active: true },
          ],
          pageTitle: 'Vistoriador',
          rule: 'editor',
        },
      },
      {
        path: '/regionais',
        name: 'Regional',
        component: () => import('./views/menu/cadastros/regionais.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Cadastro', active: true },
          ],
          pageTitle: 'Regionais',
          rule: 'editor',
        },
      },
      {
        path: '/divisoes',
        name: 'Divisão',
        component: () => import('./views/menu/cadastros/divisoes.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Cadastro', active: true },
          ],
          pageTitle: 'Divisões',
          rule: 'editor',
        },
      },
      {
        path: '/setores',
        name: 'Setor',
        component: () => import('./views/menu/cadastros/setores.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Cadastro', active: true },
          ],
          pageTitle: 'Setores',
          rule: 'editor',
        },
      },
      {
        path: '/tipoAtendimento',
        name: 'Tipo de Atendimento',
        component: () => import('./views/menu/cadastros/tipoAtendimento.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Cadastro', active: true },
          ],
          pageTitle: 'Tipo de Atendimento',
          rule: 'editor',
        },
      },
      {
        path: '/perfis',
        name: 'Perfil de Usuário',
        component: () => import('./views/menu/cadastros/perfis.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Cadastro', active: true },
          ],
          pageTitle: 'Perfil de Usuário',
          rule: 'editor',
        },
      },
      {
        path: '/contasBancarias',
        name: 'Contas Bancárias',
        component: () => import('./views/menu/cadastros/contasBancarias.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Cadastro', active: true },
          ],
          pageTitle: 'Contas Bancárias',
          rule: 'editor',
        },
      },
      {
        path: '/carteiraCobranca',
        name: 'Carteira de Cobrança',
        component: () => import('./views/menu/cadastros/carteirasCobranca.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Cadastro', active: true },
          ],
          pageTitle: 'Carteira de Cobrança',
          rule: 'editor',
        },
      },
      {
        path: '/permissoes',
        name: 'Permissões',
        component: () => import('./views/menu/cadastros/permissoes.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Cadastro', active: true },
          ],
          pageTitle: 'Permissões',
          rule: 'editor',
        },
      },
      {
        path: '/mensageria',
        name: 'Mensageria',
        component: () =>
          import('./views/menu/cadastros/Mensageria/mensageria-list.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Mensageria', active: true },
          ],
          pageTitle: 'Mensageria',
          rule: 'editor',
        },
      },
      {
        path: '/mensageria/novo',
        name: 'MensageriaNovo',
        component: () =>
          import('./views/menu/cadastros/Mensageria/mensageria-form.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Mensageria  ', url: '/mensageria' },
            { title: 'Cadastro Mensagem', active: true },
          ],
          pageTitle: 'Cadastro Mensagem',
          checkPermission: false, // TODO: Verificar permissão
          rule: 'editor',
        },
      },
      {
        path: '/mensageria/editar/:idMensagem',
        name: 'MensageriaEditar',
        component: () =>
          import('./views/menu/cadastros/Mensageria/mensageria-form.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Mensageria', url: '/mensageria' },
            { title: 'Edição Mensagem', active: true },
          ],
          pageTitle: 'Edição Mensagem',
          checkPermission: false, // TODO: Verificar permissão
          rule: 'editor',
        },
      },
      {
        path: '/programaAfiliados',
        name: 'Programa de Afiliados',
        component: () => import('./views/menu/cadastros/programaAfiliados.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Programa de Afiliados', active: true },
          ],
          pageTitle: 'Programa de Afiliados',
          rule: 'editor',
        },
      },
      {
        path: '/programaAfiliadosMetas/:id',
        name: 'Metas por Programa de Afiliados',
        component: () =>
          import('./views/menu/tabelas/programaAfiliadosMetas.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Programa de Afiliados', url: '/programaAfiliados' },
            { title: 'Metas por Programa de Afiliados', active: true },
          ],
          pageTitle: 'Metas por Programa de Afiliados',
          rule: 'editor',
          checkPermission: false,
        },
      },
      {
        path: '/fornecedor',
        name: 'Fornecedor',
        component: () => import('./views/menu/cadastros/fornecedor.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Fornecedor', active: true },
          ],
          pageTitle: 'Fornecedor',
          rule: 'editor',
        },
      },
      {
        path: '/tiposFornecedor',
        name: 'TiposFornecedor',
        component: () => import('./views/menu/tabelas/tiposFornecedor.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Fornecedor', url: '/fornecedor' },
            { title: 'Tipo de Fornecedor', active: true },
          ],
          pageTitle: 'Tipo de Fornecedor',
          checkPermission: false,
          rule: 'editor',
        },
      },
      {
        path: '/classe',
        name: 'Classe',
        component: () => import('./views/menu/cadastros/classe.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Classe', url: '/classe' },
            { title: 'Classe', active: true },
          ],
          pageTitle: 'Classe',
          checkPermission: true,
          rule: 'editor',
        },
      },
      {
        path: '/apolice',
        name: 'Apólice',
        component: () => import('./views/menu/cadastros/apolice.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Apólice', active: true },
          ],
          pageTitle: 'Apólice',
          rule: 'editor',
        },
      },
      {
        path: '/apolices-globais',
        name: 'Apólices Globais',
        component: () =>
          import('./views/pages/apolicesGlobais/apolicesGlobais.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Apólices Globais', active: true },
          ],
          pageTitle: 'Apólices Globais',
          rule: 'editor',
        },
      },
      {
        path: '/agregados',
        name: 'Agregados',
        component: () => import('./v2/PageLoader.vue'),
      },
      // =============================================================================
      // CONFIGURAÇÕES (ADMIN)
      // =============================================================================
      {
        path: '/produtos',
        name: 'Produto',
        component: () => import('./views/menu/configuracoes/produtos.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Configurações', active: true },
          ],
          pageTitle: 'Produtos',
          rule: 'editor',
        },
      },
      {
        path: '/contrato',
        name: 'Contrato',
        component: () => import('./views/menu/configuracoes/contrato.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Configurações', active: true },
          ],
          pageTitle: 'Contratos',
          rule: 'editor',
        },
      },
      {
        path: '/campanha',
        name: 'Campanha',
        component: () => import('./views/menu/configuracoes/campanha.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Configurações', active: true },
          ],
          pageTitle: 'Campanhas',
          rule: 'editor',
        },
      },
      {
        path: '/tipoPagamento',
        name: 'Tipo de Pagamento',
        component: () => import('./views/menu/configuracoes/tipoPagamento.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Configurações', active: true },
          ],
          pageTitle: 'Tipo de Pagamentos',
          rule: 'editor',
        },
      },
      {
        path: '/beneficios',
        name: 'Benefícios / Coberturas',
        component: () => import('./views/menu/configuracoes/beneficios.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Configurações', active: true },
          ],
          pageTitle: 'Benefícios / Coberturas',
          rule: 'editor',
        },
      },
      {
        path: '/tipoFotos',
        name: 'Tipo de Foto',
        component: () => import('./views/menu/configuracoes/tipoFotos.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Configurações', active: true },
          ],
          pageTitle: 'Tipo de Fotos',
          rule: 'editor',
        },
      },
      {
        path: '/tipos-arquivos-vistoria',
        name: 'Tipos de Arquivos Vistoria',
        component: () => import('./v2/PageLoader.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Configurações', active: true },
          ],
          pageTitle: 'Tipos de Arquivos Vistoria',
          rule: 'editor',
        },
      },
      {
        path: '/restricoes',
        name: 'Restrições',
        component: () => import('./views/menu/configuracoes/restricoes.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Configurações', active: true },
          ],
          pageTitle: 'Restrições',
          rule: 'editor',
        },
      },
      {
        path: '/integracaoSGA',
        name: 'Integração SGA',
        component: () => import('./views/menu/configuracoes/integracaoSGA.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Configurações', active: true },
          ],
          pageTitle: 'Integração SGA',
          rule: 'editor',
        },
      },
      {
        path: '/integracoes',
        name: 'Integrações',
        component: () => import('./views/menu/configuracoes/integracoes.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Configurações', active: true },
          ],
          pageTitle: 'Integrações',
          rule: 'editor',
        },
      },
      {
        path: '/traducoes',
        name: 'Traduções',
        component: () => import('./v2/PageLoader.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Configurações', active: true },
          ],
          pageTitle: 'Traduções',
          rule: 'editor',
        },
      },
      {
        path: '/listIntegracaoDePara/:idIntegracao',
        name: 'De-Para',
        component: () =>
          import('./views/menu/configuracoes/integracaoSGA-dePara.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Configurações', active: true },
          ],
          pageTitle: 'De-Para',
          rule: 'editor',
          checkPermission: false,
        },
      },
      {
        path: '/status',
        name: 'Status',
        component: () =>
          import('./views/menu/configuracoes/Status/StatusView.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Status', active: true },
          ],
          pageTitle: 'Status',
          rule: 'editor',
        },
      },
      {
        path: '/notificacoes/nova-notificacao',
        name: 'Nova Notificação',
        component: () =>
          import('./views/menu/notificacoes/novaNotificacao.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Notificações', active: true },
          ],
          pageTitle: 'Nova Notificação',
          rule: 'editor',
        },
      },
      {
        path: '/notificacoes',
        name: 'Listar Notificações',
        component: () => import('./views/menu/notificacoes/notificacoes.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Notificações', active: true },
          ],
          pageTitle: 'Listar Notificações',
          rule: 'editor',
        },
      },
      // =============================================================================
      // TABELAS
      // =============================================================================
      {
        path: '/simulador',
        name: 'Simulador',
        component: () => import('./views/menu/tabelas/simulador.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Tabelas', active: true },
          ],
          pageTitle: 'Simulador',
          rule: 'editor',
        },
      },
      {
        path: '/grupoVeiculos',
        name: 'Grupo de Veículos',
        component: () => import('./views/menu/tabelas/grupoVeiculos.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Grupos', active: true },
          ],
          pageTitle: 'Grupo de Veículos',
          rule: 'editor',
        },
      },
      {
        path: '/listGruposModelos/:id',
        name: 'listGruposModelos',
        component: () =>
          import('./views/menu/tabelas/grupoVeiculosModelos.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Grupos', url: '/grupoVeiculos' },
            { title: 'Modelos Associados', active: true },
          ],
          pageTitle: 'Modelos Associados ao Grupo',
          rule: 'editor',
          checkPermission: false,
        },
      },
      {
        path: '/listGruposAcessorios/:id',
        name: 'listGruposAcessorios',
        component: () =>
          import('./views/menu/tabelas/grupoVeiculosAcessorios.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Grupos', url: '/grupoVeiculos' },
            { title: 'Acessorios Associados', active: true },
          ],
          pageTitle: 'Acessorios Associados ao Grupo',
          rule: 'editor',
          checkPermission: false,
        },
      },
      {
        path: '/tabelas',
        name: 'Tabelas',
        component: () => import('./views/menu/tabelas/tabelas.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Tabelas', active: true },
          ],
          pageTitle: 'Tabelas',
          rule: 'editor',
        },
      },
      {
        path: '/listTabelaValores/:id',
        name: 'listTabelaValores',
        component: () => import('./views/menu/tabelas/valores.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Tabelas', url: '/Tabelas' },
            { title: 'Valores', active: true },
          ],
          pageTitle: 'Valores',
          rule: 'editor',
          checkPermission: false,
        },
      },
      {
        path: '/listTabelaEstadosCidades/:id',
        name: 'listTabelaEstadosCidades',
        component: () => import('./views/menu/tabelas/estadosCidades.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Tabelas', url: '/Tabelas' },
            { title: 'Estados e Cidades', active: true },
          ],
          pageTitle: 'Estados e Cidades',
          rule: 'editor',
          checkPermission: false,
        },
      },
      {
        path: '/blackList',
        name: 'Black List',
        component: () => import('./views/menu/tabelas/blackList.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Tabelas', active: true },
          ],
          pageTitle: 'Black List',
          rule: 'editor',
        },
      },
      {
        path: '/listRastreadores',
        name: 'Lista Rastreadores',
        component: () => import('./views/menu/tabelas/listRastreadores.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Tabelas', active: true },
          ],
          pageTitle: 'Lista de Rastreadores',
          rule: 'editor',
        },
      },
      {
        path: '/listParticipacoes',
        name: 'Lista Participações',
        component: () => import('./views/menu/tabelas/listParticipacoes.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'Tabelas', active: true },
          ],
          pageTitle: 'Lista de Participações',
          rule: 'editor',
        },
      },
      {
        path: '/login-empresa',
        name: 'login-empresa',
        component: () => import('@/views/pages/LoginMultiEmpresa.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/update-login-empresa',
        name: 'update-login-empresa',
        component: () => import('@/views/pages/LoginUpdateMultiEmpresa.vue'),
      },
      {
        path: '/401',
        name: 'pageError401',
        component: () => import('@/views/pages/Error401.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/bem-vindo',
        name: 'bem-vindo',
        component: () => import('@/views/pages/WelcomePage.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/financeiro/projetai',
        name: 'Projetaí',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
      {
        path: '/financeiro/saldo-certo',
        name: 'Saldo Certo',
        component: () => import('./v2/PageLoader.vue'),
        meta: { checkPermission: false },
      },
    ],
  },
  // =============================================================================
  // FULL PAGE LAYOUTS
  // =============================================================================
  {
    path: '',
    component: () => import('@/layouts/full-page/FullPage.vue'),
    children: [
      {
        path: '/Login',
        name: 'pageLogin',
        component: () => import('@/views/pages/Login.vue'),
      },
      {
        path: '/TrocarSenha',
        name: 'trocaSenha',
        component: () => import('@/views/pages/trocarSenha.vue'),
      },
      {
        path: '/proposta/:chave',
        // BEFORE ENTER MANTIDO (Assíncrono específico)
        beforeEnter: (to, from, next) => rotasEmpresas(to, next),
        name: 'proposta',
        component: () => import('@/views/pages/Invoice.vue'),
      },
      {
        path: '/propostas/:chave',
        name: 'propostaBP',
        component: () => import('@/views/pages/Invoice2.vue'),
        meta: { requiresAuth: true, checkPermission: false },
      },
      {
        path: '/multi-propostas/:chave',
        name: 'multiPropostaBP',
        component: () => import('@/views/pages/InvoiceMulti.vue'),
      },
      {
        path: '/novaProposta/:idEmpresa',
        name: 'novaProposta',
        component: () => import('@/views/pages/novaProposta.vue'),
      },
      {
        path: '/novaProposta/:idEmpresa/:userName',
        name: 'novaPropostaUser',
        component: () => import('@/views/pages/novaProposta.vue'),
      },
      {
        path: '/novaOuvidoria/:idEmpresa',
        name: 'novaOuvidoria',
        component: () => import('@/views/pages/novaOuvidoria.vue'),
      },
      {
        path: '/ChamadoResposta/:idChamado',
        name: 'ChamadoResposta',
        component: () => import('@/views/pages/ChamadoResposta.vue'),
      },
      {
        path: '/admbptech',
        name: 'Painel Administração',
        component: () => import('@/views/pages/ADMBTX.vue'),
        meta: { requiresAuth: true }, // Adicionado auth explicitamente
      },
      {
        path: '/admfilas',
        name: 'admfilas',
        component: () => import('@/views/pages/ADMFilas.vue'),
      },
      {
        path: '/admcreditos',
        name: 'Painel Créditos',
        component: () => import('@/views/pages/ADMCreditos.vue'),
        pageTitle: 'Painel Créditos',
        meta: { requiresAuth: true }, // Adicionado auth explicitamente
      },
      {
        path: '/painelAssistencia',
        name: 'painelAssistencia',
        component: () => import('@/views/pages/painelAssistencia.vue'),
      },
      {
        path: '/arquivoImpressao/:idRateio',
        name: 'arquivoImpressao',
        component: () => import('@/views/pages/arquivoImpressaoRateio.vue'),
      },
      {
        path: '/boleto/:idRegistroFinanceiro',
        name: 'boletoByIdRegistroFinanceiro',
        component: () => import('@/views/pages/Boleto.vue'),
      },
      {
        path: '/boleto/:idRegistroFinanceiro/:nossoNumero',
        name: 'boletoByNossoNumero',
        component: () => import('@/views/pages/Boleto.vue'),
      },
      {
        path: '/checklistImpressao/:idChecklist/:motivo',
        name: 'checklistImpressao',
        component: () => import('@/views/pages/ChecklistImpressao.vue'),
      },
      {
        path: '/contratoAdesao/:chave',
        name: 'contratoAdesao',
        component: () => import('@/views/pages/ContratoAdesao.vue'),
        meta: { requiresAuth: true, checkPermission: false },
      },
      {
        path: '/termoContrato/:idModelo/:chave',
        name: 'termoContrato',
        component: () => import('@/views/pages/TermosDoContrato.vue'),
        meta: { requiresAuth: true, checkPermission: false },
      },
      {
        path: '/laudoVistoria/:chave',
        name: 'laudoVistoria',
        component: () => import('@/views/pages/LaudoVistoria.vue'),
        meta: { requiresAuth: true, checkPermission: false },
      },
      {
        path: '/propostasBP/:chave',
        name: 'invoiceBP-3',
        component: () => import('@/views/pages/Invoice3.vue'),
      },
      {
        path: '/maintenance',
        name: 'pageMaintenance',
        component: () => import('@/views/pages/Maintenance.vue'),
      },
      {
        path: '/certificadoSeguradora',
        name: 'certificadoSeguradora',
        component: () => import('@/views/pages/CertificadoSeguradora.vue'),
      },
      {
        path: '/eventoPDF/:chave',
        name: 'eventoPDF',
        component: () => import('@/views/pages/EventosView.vue'),
      },
    ],
  },
  // =============================================================================
  // SEGUNDA VIA DE BOLETO
  // =============================================================================
  {
    path: '/segunda-via-boleto/',
    name: 'segundaViaBoleto',
    component: () =>
      import('@/views/pages/SegundaViaBoleto/segundaViaBoleto.vue'),
  },
  // =============================================================================
  // PÁGINA 404
  // =============================================================================
  {
    path: '/pages/error-404',
    name: 'pageError404',
    component: () => import('@/views/pages/Error404.vue'),
    meta: { checkPermission: false, requiresAuth: false },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/pages/error-404',
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior() {
    return { left: 0, top: 0 };
  },
  routes,
});

// =============================================================================
// GLOBAL GUARDS (Substitui os beforeEnter individuais)
// =============================================================================
router.beforeEach((to, from, next) => {
  // 1. Manutenção (Prioridade Máxima)
  const isMaintenance = process.env.VUE_APP_MAINTENANCE === 'true';
  if (isMaintenance && to.name !== 'pageMaintenance') {
    return next('/maintenance');
  }
  if (!isMaintenance && to.name === 'pageMaintenance') {
    return next('/');
  }

  // 2. Autenticação (Se a rota exigir)
  // Verifica se a rota ou qualquer pai na cadeia exige auth
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // 2.1 Verifica Domínio (Lógica antiga movida para cá para proteger as rotas internas)
    const dominio = window.location.href.toString();
    const query = window.location.search;

    if (
      (dominio.indexOf('certificado.bpseguradora') >= 0 ||
        dominio.indexOf('certificado.igreenseguros') >= 0) &&
      to.path !== '/certificadoSeguradora'
    ) {
      return next('/certificadoSeguradora' + query);
    }

    if (
      dominio.indexOf('cotacao.bemprotege') >= 0 &&
      to.path !== '/landing-page-BP'
    ) {
      return next('/landing-page-BP' + query);
    }

    // 2.2 Verifica Token
    const token = localStorage.getItem('user-token');
    if (!token) {
      localStorage.setItem('rotaEntrada', window.location.href.toString());
      return next('/Login');
    }

    // 2.3 Verifica Expiração do Token
    const decoded = jwt.decode(token);
    if (!decoded || (decoded.exp && Date.now() >= decoded.exp * 1000)) {
      return next('/Login');
    }

    // 2.4 Valida Permissões ACL (Se passar aqui, entra na rota)
    return validatePermission(to, next);
  }

  // Se a rota não exige auth, libera o acesso direto
  next();
});

router.afterEach(() => {
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = 'none';
  }
});

// =============================================================================
// FUNÇÕES AUXILIARES
// =============================================================================

function validatePermission(to, next) {
  // Se a rota tem uma flag explícita para pular checagem
  if (to.meta.checkPermission !== undefined && !to.meta.checkPermission) {
    return next();
  }

  const permission = ability.getPermission();
  if (permission && permission.can('Leitura', to.name)) {
    return next();
  }

  if (to.fullPath === '/dashboard') {
    return next('/bem-vindo');
  }

  next('/401');
}

function rotasEmpresas(to, next) {
  let idEmpresa = 0;
  service
    .getAll('CotacaoAberta', null, 'getIdEmpresa/' + to.params.chave)
    .then((res) => {
      idEmpresa = res.data.id_empresa;
      if (functions.verificaEmpresaBemProtege(idEmpresa)) {
        next(`/propostas/${to.params.chave}`);
      } else {
        next();
      }
    })
    .catch((e) => {
      console.error(e);
      // Em caso de erro na API, decidimos se bloqueamos ou deixamos passar.
      // Por segurança, deixamos passar para a rota original ou tratamos o erro.
      next();
    });
}

// Cache por sessão: evita chamada à API a cada navegação dentro da mesma empresa
var _eventosBlockedCache = new Map();

function _isEventosRoute(path) {
  return (
    path === '/eventos' ||
    path.startsWith('/eventos/') ||
    path === '/novo-evento'
  );
}

function _checkEventosBlock(idEmpresa, next) {
  if (_eventosBlockedCache.has(idEmpresa)) {
    var blocked = _eventosBlockedCache.get(idEmpresa);
    return blocked ? next('/bem-vindo') : next();
  }
  service
    .getAll('g', {}, 'empresas/list/idEmpresa/' + idEmpresa)
    .then(function (res) {
      var empresa = decryptData(res.data)[0];
      var blocked = Boolean(empresa && empresa.naoPodeAbrirSinistro);
      _eventosBlockedCache.set(idEmpresa, blocked);
      blocked ? next('/bem-vindo') : next();
    })
    .catch(function () {
      next();
    });
}

router.beforeEach(function (to, from, next) {
  if (!_isEventosRoute(to.path)) return next();

  var token = localStorage.getItem('user-token');
  if (!token) return next();

  var decoded = jwt.decode(token);
  var idEmpresa = decoded && decoded.id_empresa;
  if (!idEmpresa) return next();

  _checkEventosBlock(idEmpresa, next);
});

export default router;
